var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-wrapper',{staticClass:"py-8"},[_c('number-chart',{attrs:{"is-loading":_vm.isLoading,"value":_vm.value,"title":"Fully Automated","id":"fully-automated-number","hint":_vm.hint,"suffix":"%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }